import { render, staticRenderFns } from "./PublicWidgetDonation.vue?vue&type=template&id=c2f235c0&scoped=true"
import script from "./PublicWidgetDonation.vue?vue&type=script&lang=js"
export * from "./PublicWidgetDonation.vue?vue&type=script&lang=js"
import style0 from "./PublicWidgetDonation.vue?vue&type=style&index=0&id=c2f235c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f235c0",
  null
  
)

export default component.exports